import React, { useEffect, useRef, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Button, Image, Modal } from "react-bootstrap";
import { IoPersonCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { HandleLogout } from "../../common/Logout";
import { useContextProvider } from "../../context/ContextProvider";
import mgatelogo from "./logo-gold-blac.png";
import Timeline from "../Timeline/Timeline";
import Help from "../Help/Help";
import "./SideMenu.css";
import { FaBell } from "react-icons/fa";
import {GetTimelinesCount} from "../../API/Axios";
import { useQuery } from "react-query";
const TopBar = ({ pageTitle }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  const [timelinesCount, setTimelinesCount] = useState(() => {
    const savedCount = sessionStorage.getItem("timelinesCount");
    return savedCount ? parseInt(savedCount, 10) : 0;
  });
  const { toggleSideMenu, setLogout, setIsSideMenuCollapsed } =
    useContextProvider();
  const [showHelp, setShowHelp] = useState(false);
  const handleLogout = () => {
    setLogout(true);
    HandleLogout();
  };

  const ref = useRef(null);
  const navigate = useNavigate();

  const handleOutsideClick = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowMenu(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showMenu]);

  const buttonStyle = {
    display: "block",
    width: "100%",
    textAlign: "left",
    padding: "8px 12px",
    margin: "0",
    border: "none",
    background: "none",
    color: "#000",
    cursor: "pointer",
  };

  const profile = {
    position: "absolute",
    top: "60px",
    right: "10px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "10px",
    zIndex: "100",
    width: "150px",
  };

  const buttonHoverStyle = {
    ...buttonStyle,
    backgroundColor: "#f8f9fa",
  };

  const { refetch: refetchTimelinesCount, isFetching: isFetchingTimelinesCount } = useQuery(
      ['getTimelinesCount'],
      () => GetTimelinesCount(sessionStorage.getItem("username")), 
      {
        refetchOnWindowFocus: false,
        onSuccess: (res) => {
            const existingTimelinesCount = sessionStorage.getItem("timelinesCount");
            if (existingTimelinesCount === null) {  
              sessionStorage.setItem("timelinesCount", res?.ResponseCode || 0);
              setTimelinesCount(res?.ResponseCode);
            }
        },
        onError: (error) => {
          console.error(error);
        },
      }
    );

    useEffect(() => {
        refetchTimelinesCount();
    }, []);
  return (
    <div>
      <Navbar className="justify-content-between">
        <Navbar.Brand className="mx-3" style={{ fontSize: "30px" }}>
          <p> {pageTitle}</p>
        </Navbar.Brand>
        <div className="d-flex align-items-center justify-content-between mx-5" ref={ref}>
        <Button
            variant="light"
            onClick={() => setShowHelp(true)} 
            style={{ cursor: "pointer"}}
          >
            Help
          </Button>
          {timelinesCount > 0 ? (
            <span
              style={{
                cursor: "pointer",
                position: "relative",
                fontSize: "16px",
                fontWeight: "bold",
                paddingLeft: "15px",
                paddingRight: "25px",
                bottom: "-7px",
              }}
              onClick={() => setShowTimeline(true)}
            >
              <FaBell size={24} />
              <span
                style={{
                  position: "inherit",
                  top: "-35px",
                  right: "-10px",
                  backgroundColor: "#ff3b30",
                  color: "white",
                  borderRadius: "50%",
                  minWidth: "20px",
                  height: "20px",
                  padding: "2px 4px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {timelinesCount}
              </span>
            </span>
          ) : (
            <Button
              variant="light"
              onClick={() => setShowTimeline(true)}
              style={{
                cursor: "pointer",
                position: "relative",
                fontSize: "16px",
                fontWeight: "unset",
              }}
            >
              Timelines
            </Button>
          )}
          <span
            style={{ cursor: "pointer" }}
            variant="light"
            onClick={() => setShowMenu((prev) => !prev)}
          >
            <IoPersonCircleSharp size={"35px"} />
          </span>
          {showMenu && (
            <div style={profile}>
              <Button
                className="my-1 p-2"
                variant="secondary"
                style={showMenu ? buttonHoverStyle : buttonStyle}
                onClick={() => navigate("/profile")}
              >
                Profile
              </Button>
              <Button
                variant="secondary"
                style={showMenu ? buttonHoverStyle : buttonStyle}
                onClick={() => handleLogout()}
              >
                Logout
              </Button>
            </div>
          )}
        </div>
      </Navbar>
      <Modal
        show={showTimeline}
        onHide={() => {
          setShowTimeline(false);
          sessionStorage.setItem("timelinesCount", 0);
          setTimelinesCount(0);
          }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Timeline</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Timeline /> {/* Timeline Component inside Modal */}
        </Modal.Body>
      </Modal>
      <Modal
        show={showHelp}
        onHide={() => setShowHelp(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Help /> 
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TopBar;
